import { useState } from 'react'
import Flex from '@dd3tech/wiggui/Flex'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import OptionButton from '@dd3tech/wiggui/OptionButton'
import Modal from '@dd3tech/wiggui/Modal'
import Spinner from '@dd3tech/wiggui/Spinnner'
import Text from '@dd3tech/wiggui/Text'
import { ShareWithContactLead } from './components/ShareWithContactLead'
import { useShareFilePropertyV2 } from '../hooks/useShareFilePropertyV2'
import ModalDownloadPdf from './components/ModalDownloadPdf'
import { OptionsSwitch } from '../../options-switch'
import { Shapes } from '../../../svg/Shapes'

export const ModalShareFilePropertyV2 = () => {
  const [activeOption, setActiveOption] = useState<'lead' | 'broker'>('lead')
  const options = [
    {
      label: (
        <div className="flex items-center gap-2 h-[28px]">
          <GoogleIcon name="people" className="text-xl" /> Para prospectos
        </div>
      ),
      value: 'lead'
    },
    {
      label: (
        <div className="flex items-center gap-2 h-[28px]">
          <GoogleIcon name="assignment_ind" className="text-xl" />
          Para asesores
        </div>
      ),
      value: 'broker'
    }
  ]
  const {
    isOpen,
    property,
    onClose,
    setShowModalPDF,
    showModalPDF,
    isLoading
  } = useShareFilePropertyV2()

  if (!isOpen) {
    return null
  }

  return (
    <>
      <ModalDownloadPdf
        propertyType={property?.propertyType || ''}
        legacyId={property?.legacyId || ''}
        neighborhood={property?.neighborhood || ''}
        dataPrice={{
          saleActive: property?.saleActive || null,
          leaseActive: property?.leaseActive || null,
          presaleActive: property?.presaleActive || null,
          salePrice: property?.salePrice || null,
          leasePrice: property?.leasePrice || null,
          presalePrice: property?.presalePrice || null
        }}
        propertyId={property?.propertyId || ''}
        showModalShareFile={isOpen}
        setShowModal={setShowModalPDF}
        showModal={showModalPDF}
      />
      <Modal
        isOpen={isOpen && !showModalPDF}
        onClose={onClose}
        enableBgBlur
        isResponsive
        className="max-w-2xl w-full"
      >
        <div className="bg-notif-turquoise-01 px-6 pb-6 flex flex-col rounded-xl gap-6 w-full relative">
          <div className="absolute right-0 top-0 z-[0]">
            <Shapes />
          </div>
          <Flex
            dir="row"
            items="center"
            className="pt-3 pb-1 z-1"
            wFull
            justify="between"
            gap="gap-3"
          >
            <Text as="p" className="font-semibold text-body-bold-xl">
              Compartir
            </Text>
            <OptionButton
              className="!bg-overlay-dark hover:!bg-[#2222229f] active:!bg-surface-dark transition-colors duration-300 ease-in-out"
              onClick={onClose}
              onlyIcon={
                <GoogleIcon name="close" className="text-[24px] text-white" />
              }
            />
          </Flex>
          <div className="w-full flex justify-center">
            <OptionsSwitch
              classNameOption="!py-0"
              className="!bg-[#222222]/40 backdrop-blur-20"
              options={options}
              onChange={(value: any) => {
                setActiveOption(value)
              }}
              activeOption={activeOption}
              checkBlack
            />
          </div>
          <Flex
            dir="row"
            items="center"
            wFull
            gap="gap-2"
            className="p-2 bg-notif-turquoise-01 backdrop-blur-20 rounded-lg h-[76px]"
          >
            <GoogleIcon className="text-[14px]" name="info" />
            <Text as="p" className="font-semibold text-body-bold-m w-full">
              {activeOption === 'lead'
                ? 'Comparte la información pública de tu propiedad con un prospecto'
                : 'Comparte la ficha de tu propiedad con un asesor. Solo estará disponible dentro de Wiggot.'}
            </Text>
          </Flex>
          {isLoading && (
            <div className="flex items-center justify-center w-full">
              <Spinner customBorderColor="border-t-primary" />
            </div>
          )}
          {property && (
            <ShareWithContactLead
              setShowModal={setShowModalPDF}
              property={property}
              type={activeOption}
            />
          )}
        </div>
      </Modal>
    </>
  )
}
